export default "__VITE_PUBLIC_ASSET__d07822af__"